<template>
  <div
    class="d-flex flex-column overflow-auto fill-height pt-2"
    :class="{ 'grey lighten-4': !noBackground }"
  >
    <event-log-item
      v-for="(eventLog, i) in eventLogs"
      :key="eventLog.id"
      :reference="reference"
      :reference-event-log="eventLog"
      :current-researcher="currentResearcher"
      :bottom-node="i === eventLogs.length - 1"
    />
    <div
      v-if="isEmpty && !noEmptyState"
      class="d-flex justify-center align-center fill-height"
    >
      <page-content-placeholder
        icon="history"
        prompt-text="No history yet"
        small
      >
        <template #message>
          Once an event is created it will appear here
        </template>
      </page-content-placeholder>
    </div>
  </div>
</template>

<script>
import EventLogItem from './EventLogItem';
import PageContentPlaceholder from '@/components/Common/PageContentPlaceholder';
import { typeHelpers } from '@/modules';
import { ReferenceEventLog, Reference, Researcher } from '@/models';

export default {
  name: 'EventLog',
  components: {
    EventLogItem,
    PageContentPlaceholder,
  },
  props: {
    reference: {
      type: Reference,
      required: true,
    },
    eventLogs: {
      type: Array,
      required: true,
      validator: (eventLogs) =>
        typeHelpers.isArrayOfType(eventLogs, ReferenceEventLog),
    },
    currentResearcher: {
      type: Researcher,
      default: null,
    },
    noBackground: {
      type: Boolean,
      default: false,
    },
    noEmptyState: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isEmpty() {
      return this.eventLogs.length === 0;
    },
  },
};
</script>
